import { render, staticRenderFns } from "./WidgetDoughnut.vue?vue&type=template&id=7e879658&scoped=true&"
import script from "./WidgetDoughnut.vue?vue&type=script&lang=js&"
export * from "./WidgetDoughnut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e879658",
  null
  
)

export default component.exports